// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2YXu_","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__CcS1q"};